export * from './contract.component'